function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["icon"] || "icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M72.533 631.467h85.334v256H72.533zm170.667-128h85.333v384H243.2zm170.667-128H499.2v512h-85.333zm170.666-128h85.334v640h-85.334zm170.667-128h85.333v768H755.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.325 81.43l72.406-72.427 865.856 865.877-72.406 72.405z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.379 145.13L74.73 84.78 928.533 938.58l-60.352 60.352z",
  fill: "#ec6f41",
  "data-spm-anchor-id": "a313x.search_index.0.i0.1bce3a81KDxd5R",
  className: styles["selected"] || "selected"
}));